import { BreakPoints, BREAK_POINTS_DIMENSIONS_VALUES_IN_PX } from '@soluto-home-web/platform-common-ui';

export const ACCENT_COLOR = '#004BDC';

export const NAV_HEIGHT_MOBILE = 65;
export const NAV_HEIGHT_DESKTOP = 80;
export const HEIGHT_MOBILE = NAV_HEIGHT_MOBILE;
export const HEIGHT_DESKTOP = NAV_HEIGHT_DESKTOP;

export const PAGE_SCROLL_THRESHOLD = 100;

export const BREAKPOINT_PX_DESKTOP = BREAK_POINTS_DIMENSIONS_VALUES_IN_PX.desktop;
export const BREAKPOINT_MOBILE = `(max-width: ${BREAKPOINT_PX_DESKTOP - 1}px)`;
export const BREAKPOINT_DESKTOP = BreakPoints.desktop;
export const BREAKPOINT_PX_LARGE_DESKTOP = 1200;
export const BREAKPOINT_LARGE_DESKTOP = `(min-width: ${BREAKPOINT_PX_LARGE_DESKTOP}px)`;



// WEBPACK FOOTER //
// ./packages/smart-home-support/components/Header/constants.ts